import moment from 'moment';

const dateTimeFilters = {
  dateFilter: function (date, format) {
    
    return moment(date).format(format);
  }
}

export default dateTimeFilters;